<button
  #tooltipDirectiveRef="uiTooltip"
  [ngClass]="backgroundClass"
  [uiTooltipTitle]="tooltip | localize"
  [uiTooltipOverlayStyle]="indicatorTooltipCustomStyle"
  (click)="onButtonClick(tooltipDirectiveRef)"
  uiTooltipPlacement="bottomRight"
  data-test-id="suggestion-state-indicator"
  tabindex="-1"
  ui-tooltip>
  <div class="sp-p-8 suggestion-state-indicator-overlay" [class.suggestion-state-indicator-selected]="isSelected">
    <i class="fs-16px" [uiType]="icon" ui-icon></i>
  </div>
</button>
<onboarding
  *ngIf="onboarding && onboarding.shouldShow"
  [delegate]="onboarding.delegate"
  [steps]="onboarding.totalSteps"
  [startFromStep]="onboarding.startingStep"
  [hideSecondaryButton]="true"
  [hideSteps]="true"
  section="suggestionStateIndicator"></onboarding>
